import { Observable } from 'rxjs';

import { UseCase } from '@domain-utils/use-case';
import { IdentityRepository } from '@model/identity';

/**
 * Caso de uso para obtener la URL de logout del sistema de seguridad
 */
export class GetLogoutUrlUseCase implements UseCase<void, string> {
  /**
   * Constructor del caso de uso
   * @param _identityRepository Repositorio de seguridad
   */
  constructor(private _identityRepository: IdentityRepository) {}

  /**
   * Método que ejecuta el caso de uso
   * @returns Observable con la URL de logout
   */
  execute(): Observable<string> {
    return this._identityRepository.getLogoutUrl();
  }
}
